import { Spinner } from "react-bootstrap";

const LoadingView = () => (
    <Spinner animation="border" role="status">
      <span className="visually-hidden">Loading...</span>
    </Spinner>
)

export default LoadingView